export default [
  {
    path: '/customSetting',
    name: 'customSetting',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/utility/customSetting/CustomSetting.vue'),
    meta: {},
  },
  // {
  //   path: '/dictionary/datamanagement/backup',
  //   name: 'backup',
  //   component: () => import(/*webpackChunkName:'di'*/ '@/views/dictionary/dataManagement'),
  //   meta: {},
  // },
];
